import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter, redirect } from "react-router";
import { hasNativeV3Session } from "@/shared/api/current-customer";

const OnboardingPage = lazy(() => import("@/pages/onboarding/onboarding-page"));
const LoginPage = lazy(() => import("@/pages/login/login-page"));
const PasswordResetPage = lazy(() => import("@/pages/login/password-reset-page"));
const MenuPage = lazy(() => import("@/pages/menu/menu-page"));
const DashboardPage = lazy(() => import("@/pages/dashboard/dashboard-page"));
const SubscribePage = lazy(() => import("@/pages/subscribe/subscribe-page"));
const CheckoutPage = lazy(() => import("@/pages/checkout/checkout-page"));
const loadingElement = (
  <main aria-busy="true" className="route-loading">
    Loading PetChef…
  </main>
);
const loginElement = (
  <Suspense fallback={loadingElement}>
    <LoginPage />
  </Suspense>
);
const onboardingElement = (
  <Suspense fallback={loadingElement}>
    <OnboardingPage />
  </Suspense>
);
const passwordResetElement = (
  <Suspense fallback={loadingElement}>
    <PasswordResetPage />
  </Suspense>
);
const menuElement = (
  <Suspense fallback={loadingElement}>
    <MenuPage />
  </Suspense>
);
const dashboardElement = (
  <Suspense fallback={loadingElement}>
    <DashboardPage />
  </Suspense>
);
const subscribeElement = (
  <Suspense fallback={loadingElement}>
    <SubscribePage />
  </Suspense>
);
const checkoutElement = (
  <Suspense fallback={loadingElement}>
    <CheckoutPage />
  </Suspense>
);

const requireNativeV3Session = async () => {
  if (!(await hasNativeV3Session())) return redirect("/login");
  return null;
};

export const router = createBrowserRouter([
  { path: "/", element: <Navigate replace to="/login" /> },
  { path: "/login", element: loginElement },
  { path: "/reset-password", element: passwordResetElement },
  { path: "/onboarding", element: onboardingElement },
  { path: "/dashboard", element: dashboardElement, loader: requireNativeV3Session },
  { path: "/menu", element: menuElement, loader: requireNativeV3Session },
  { path: "/subscribe", element: subscribeElement, loader: requireNativeV3Session },
  { path: "/checkout/:orderId", element: checkoutElement, loader: requireNativeV3Session },
  { path: "/checkout/:orderId/return", element: checkoutElement, loader: requireNativeV3Session },
  {
    path: "/checkout/subscription/:orderId",
    element: checkoutElement,
    loader: requireNativeV3Session,
  },
  {
    path: "/checkout/subscription/:orderId/return",
    element: checkoutElement,
    loader: requireNativeV3Session,
  },
  {
    path: "/checkout/subscription-change/:agreementId/:adjustmentId",
    element: checkoutElement,
    loader: requireNativeV3Session,
  },
  {
    path: "/checkout/subscription-change/:agreementId/:adjustmentId/return",
    element: checkoutElement,
    loader: requireNativeV3Session,
  },
  { path: "*", element: <Navigate replace to="/login" /> },
]);
